import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageTitle } from "@/components/DashUI";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { MapPin, Phone, Mail } from "lucide-react";

export default function ProvidersView() {
  const [providers, setProviders] = useState([]);
  useEffect(() => { api.get("/agent/providers").then((r) => setProviders(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <PageTitle title="My Providers" subtitle="Approved participating providers in the network" />
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {providers.map((p) => (
          <Card key={p.id} className="p-6" data-testid={`agent-provider-${p.id}`}>
            <h3 className="font-heading text-base font-semibold text-navy">{p.provider_name}</h3>
            <div className="mt-2 flex flex-wrap gap-1.5">
              {(p.service_categories || []).slice(0, 3).map((s) => (
                <Badge key={s} variant="secondary" className="text-[10px]">{s}</Badge>
              ))}
            </div>
            <div className="mt-4 space-y-1.5 text-sm text-slate-500">
              <p className="flex items-center gap-1.5"><MapPin className="h-4 w-4" /> {p.city}, {p.state}</p>
              {p.phone && <p className="flex items-center gap-1.5"><Phone className="h-4 w-4" /> {p.phone}</p>}
              {p.email && <p className="flex items-center gap-1.5"><Mail className="h-4 w-4" /> {p.email}</p>}
            </div>
            {p.price_range && <p className="mt-3 text-sm font-semibold text-emeraldbrand">{p.price_range}</p>}
          </Card>
        ))}
        {providers.length === 0 && <Card className="col-span-full p-10 text-center text-slate-400">No approved providers yet. Approved providers appear here.</Card>}
      </div>
    </div>
  );
}
